import styled from '@emotion/styled';
import { Button } from '~/shared/components/Button';
import { breakpoints } from '~/theme';

export const Section = styled.div(() => ({
    display: 'grid',
}));

export const StyledWrapper = styled.div(({ theme }) => ({
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.space[3],
    marginTop: theme.space[4],
}));

export const StyledButton = styled(Button)(({ theme }) => ({
    textDecoration: 'underline',
    fontWeight: theme.fontWeights.medium,
    display: 'grid',
    justifyContent: 'end',
    span: {
        fontSize: theme.fontSizes.guinea,
    },
}));
export const Footer = styled.div(({ theme }) => ({
    position: 'relative',
    marginTop: theme.space[4],
}));

export const PageSetter = styled.div(({ theme }) => ({
    display: 'none',
    [breakpoints.md]: {
        height: '100%',
        position: 'absolute',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: theme.space[1],
    },
}));

export const Pagination = styled.div(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.space[6],
}));
